import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteLocationGroupModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteLocationGroupModalContainer" */
      './DeleteLocationGroupModalContainer'
    ),
  loading: LoadingModal,
});
